// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"1831850d","1426":"1094491c","2314":"3b45534f"}[chunkId] + ".chunk.css";
};